import { SxProps } from "@mui/material";

export const AiDrawerStyles: SxProps = {
  position: "absolute",
  left: "50%",
  width: "50vw",
  bgcolor: "white",
  borderWidth: "2px 0px 0px 2px",
  borderStyle: "solid",
  borderColor: "#872EE5",
  height: "calc(100% - 56px)",
  overflow: "auto",
  mt: "6px",
  zIndex: 999,
  borderTopLeftRadius: "20px",
};

export const ChatContainer: SxProps = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "space-between",
  bgcolor: "#fff",
};

export const HeaderStyle: SxProps = {
  height: "80px",
  borderBottom: "1px solid #E0E3EB",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  p: 2,
};

export const FlexContainer: SxProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
};

export const InputContainer: SxProps = {
  bgcolor: "#fff",
  p: "10px 20px",
};

export const AiSearchContainer: SxProps = {
  flex: "1 1",
  scrollBehavior: "smooth",
  overflow: "auto",
  display: "flex",
  p: "10px 20px",
  flexDirection: "column-reverse",
  "::-webkit-scrollbar-thumb": {
    bgcolor: "rgba(192, 192, 192, 0.4)",
  },
  "&:hover::-webkit-scrollbar-thumb": {
    bgcolor: "#b8b8b8",
  },
};
